var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", { attrs: { method: "post" } }, [
    _c("div", { staticClass: "col-md-11 p-h-xs" }, [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("redactor", {
            staticClass: "col-md-10",
            attrs: {
              type: "text",
              name: "notification_content",
              placeholder: "Content goes here.. ",
            },
            model: {
              value: _vm.notification_content,
              callback: function ($$v) {
                _vm.notification_content = $$v
              },
              expression: "notification_content",
            },
          }),
          _vm._v(" "),
          _c(
            "ladda-button",
            {
              staticClass: "btn btn-sm btn-success col-md-2",
              attrs: { type: "submit", click: _vm.saveContents },
            },
            [_vm._v("\n        Save\n      ")]
          ),
          _vm._v(" "),
          _c(
            "ladda-button",
            {
              staticClass: "btn btn-sm btn-danger col-md-2",
              attrs: { type: "submit", click: _vm.resetContents },
            },
            [_vm._v("\n        Reset\n      ")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }